import { Box, Typography } from '@mui/material';
import React from 'react';

const Home = () => (
  <Box sx={{ padding: 4, textAlign: 'center' }}>
    <Typography variant="h4" gutterBottom>
      Welcome to the Town of Diamond Valley's Health & Safety Application.
    </Typography>
    <Typography variant="body1">
      Please refer your requests to <a href="mailto:safety@diamondvalley.town">safety@diamondvalley.town</a>
    </Typography>
  </Box>
);

export default Home;